<template>
  <div class="exhibit-gallery">
    <div
      v-for="(image,ind) in images"
      :key="ind"
      class="thumbnail"
      @click="$emit('gallery-click', ind)"
    >
      <img :src="image.thumbnail">
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExhibitGallery',
  props: {
    images: {
      type: Array,
      default() {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.exhibit-gallery {
  @include grid(3);
  .thumbnail {
    cursor: pointer;
  }
}
</style>